export const ACCEPTED_CSV_SELECTION = 'ACCEPTED_CSV_SELECTION';
export const CANCELED_CSV_SELECTION = 'CANCELED_CSV_SELECTION';
export const CHANGE_EMAIL_VALUE = 'CHANGE_EMAIL_VALUE';
export const CHANGE_NEW_CONNECTION_VALUE = 'CHANGE_NEW_CONNECTION_VALUE';
export const CLEAR_STORES = 'CLEAR_STORES';
export const CONVERT_FROM_CSV = 'CONVERT_FROM_CSV';
export const CANCEL_CSV_HEADER_SELECTION = 'CANCEL_CSV_HEADER_SELECTION';
export const CHANGE_CSV_HEADER = 'CHANGE_CSV_HEADER';
export const DELETED_TEMP_CONNECTIONS = 'DELETED_TEMP_CONNECTIONS';
export const FINISH_CSV_HEADER_SELECTION = 'FINISH_CSV_HEADER_SELECTION';
export const IS_PERSISTED_FROM_SERVER = 'IS_PERSISTED_FROM_SERVER';
export const NEW_ADD_CONNECTIONS = 'NEW_ADD_CONNECTIONS';
export const RECEIVE_ADD_CONNECTIONS = 'RECEIVE_ADD_CONNECTIONS';
export const REMOVE_ADD_INVITATION = 'REMOVE_ADD_INVITATION';
export const SEND_EMAIL_TO_TEMP_CONNECTIONS = 'SEND_EMAIL_TO_TEMP_CONNECTIONS';
export const SEND_EMAIL_TO_TEMP_CONNECTIONS_STARTING = 'SEND_EMAIL_TO_TEMP_CONNECTIONS_STARTING';
export const SEND_TEMP_CONNECTIONS = 'SEND_TEMP_CONNECTIONS';
export const SEND_EMAIL_TO_TEMP_CONNECTIONS_FAILED = 'SEND_EMAIL_TO_TEMP_CONNECTIONS_FAILED';
export const UPDATE_TEMP_CONN_PROP = 'UPDATE_TEMP_CONN_PROP';



// WEBPACK FOOTER //
// ./src/app/stores/temp-connections/temp-connections-constants.js